import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getSensor(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}sensor/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function addSensor(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}sensor/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getByIdSensor(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}sensor/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateSensor(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}sensor/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddDevice() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/device/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddSensorType() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/sensor/type/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
